// A route handler is called when a matching route is navigated or resolved (when the online app router's navigate or resolve methods are called).
// These handler functions are bound to an OnlineApp instance - so `this` refers to the online app.
// Each handler's primary job is to dispatch actions (via the online app's state machine) and thru these actions set the app's state.
// There should be little logic in each handler - just interpret the route data and pass relevant results to a state machine action.

export const rootRouteHandler = function(match) {
    console.log('rootRouteHandler', match);
    // The root route is only requested when the app is first loaded.
    // The Nav will handle this situation and trigger a "click" event on the default nav option (see `Nav` class and the `renderInitial` method).
    // Therefore no action is needed here.
}

export const subpageRouteHandler = function(match) {
    console.log('subpageRouteHandler', match)
    const onlineApp = this;

    const subpage = getSubpageFromSlug(onlineApp, match);

    this.dispatchAction('subpageRouteRequested', subpage);
}

export const filterRouteHandler = function(match) {
    console.log('filterRouteHandler', match)
    const onlineApp = this;

    const mapFilter = getMapFilterFromSlug(onlineApp, match);

    this.dispatchAction('filterRouteRequested', mapFilter);
}

export const filterExperienceRouteHandler = function(match) {
    console.log('filterExperienceRouteHandler', match)
    const onlineApp = this;

    const mapFilter = getMapFilterFromSlug(onlineApp, match);
    const experience = getExperienceFromSlug(onlineApp, match);

    console.log('matched mapFilter', mapFilter);
    console.log('matched experience', experience);

    this.dispatchAction('filterExperienceRouteRequested', { mapFilter: mapFilter, experience: experience });
}

export const experienceRouteHandler = function (match) {
    console.log('experienceRouteHandler', match);
    const onlineApp = this;

    const experience = getExperienceFromSlug(onlineApp, match);

    console.log('matched experience', experience);

    // Create this action if necessary…
    // if (experience) { this.dispatchAction('experienceRouteRequested', { experience: experience }) }
}


// Private…

function getSubpageFromSlug(onlineApp, match) {
    const slug = match.data['subpage_id'];
    return onlineApp.subpageCollection.withSlug(slug);
}

function getMapFilterFromSlug(onlineApp, match) {
    const slug = match.data['filter_id'];
    return onlineApp.mapFilterCollection.withSlug(slug);
}

function getExperienceFromSlug(onlineApp, match) {
    const slug = match.data['experience_id'];
    return onlineApp.experienceCollection.withSlug(slug);
}